import { useContext, useState } from "react";
import { Accordion, Button, Spinner } from "react-bootstrap";
import { AlertContext } from "../alert/AlertContext";
import ReportService from "../../services/ReportService";

export const MasterParticipatingBusOperatorAccordian = () => { 
    const [isLoading, setIsLoading] = useState(false);
    const alertContext = useContext(AlertContext);
    if (!alertContext) return <></>;

    const reportService = new ReportService(alertContext.showAlert);

    const getReport = () => {
    setIsLoading(true);
    reportService.getMasterParticipatingBusOperatorReport().then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
  
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `master_participating_bus_operators_${new Date().toISOString()}.csv`
        );
        document.body.appendChild(link);
        link.click();
  
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
        setIsLoading(false);
    })
};

    return (
        <>
          <Accordion.Item eventKey="masterParticipatingBusOperatorReport">
            <Accordion.Header>Master Participating Bus Operator Report</Accordion.Header>
            <Accordion.Body>
              <p>
                This export will provide all fare zone stations and their operators.
              </p>
              <Button
                variant="primary"
                onClick={getReport}
                disabled={isLoading}
              >
                {!isLoading && <div>Download</div>}
                {isLoading && (
                  <>
                    Downloading...{" "}
                    <Spinner animation="border" role="status" size="sm" />
                  </>
                )}
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </>
      );


};